import React, { useState } from 'react'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import PageShell from './PageShell'
import PageContainer from './components/PageContainer'
import PageHeader from './components/PageHeader'
import DataCard from './components/DataCard'

export default function SimpleFileUpload() {
  const [selectedFile, setSelectedFile] = useState(null)

  const handleFileChange = (event) => {
    const file = event.target.files[0]
    if (file) {
      setSelectedFile(file.name)
    }
  }

  return (
    <PageShell>
      <PageContainer maxWidth={720}>
        <PageHeader
          icon={<CloudUploadIcon />}
          title="File Upload"
          subtitle="Upload a file to attach to your session"
        />
        <DataCard>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2 }}>
            <input
              type="file"
              accept="*/*"
              id="upload-button"
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
            <label htmlFor="upload-button">
              <Button variant="contained" color="primary" component="span">
                Choose File
              </Button>
            </label>
            {selectedFile && (
              <Box sx={{ fontSize: '0.95rem', color: 'text.secondary' }}>
                Selected file: <strong>{selectedFile}</strong>
              </Box>
            )}
          </Box>
        </DataCard>
      </PageContainer>
    </PageShell>
  )
}
